import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"
import Icon from "./elements/Icon"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ns-block ns-relative ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({ width: 3 })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                // scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <nav class="ns-pagination ns-w-100">
            <ol class="ns-pagination-list ns-flex ns-flex-nowrap ns-items-center ns-justify-center">
                {prev && (
                    <li>
                        <PageLink {...pageLinkProps(prev)} className="ns-previous">
                            <span class="sr-only visually-hidden">Previous page</span>
                            <svg role="presentation" aria-hidden="true" width="16" height="16" viewBox="0 0 19 15" fill="#000" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.647.146l.707.708L2.207 7H19v1H2.207l6.147 6.146-.707.708L.293 7.5 7.647.146z"></path>
                            </svg>
                        </PageLink>
                    </li>
                )}

                {first && (
                    <>
                        <li>
                            <PageLink {...pageLinkProps(first)} ariaLabel="First page">
                                {first.page}
                            </PageLink>
                        </li>
                        <li><span class="ns-pagination-spacer">...</span></li>
                    </>
                )}

                {pages.map(page => (
                    <li key={page.page} class={`${page.current ? "ns-active" : ""}`}>
                        <PageLink ariaLabel={`${page.page} page`} {...pageLinkProps(page)}>{page.page}</PageLink>
                    </li>
                ))}

                {last && (
                    <>
                        <li><span class="ns-pagination-spacer">...</span></li>
                        <li>
                            <PageLink {...pageLinkProps(last)} ariaLabel="Last page">{last.page}</PageLink>
                        </li>
                    </>
                )}

                {next && (
                    <li>
                        <PageLink {...pageLinkProps(next)} className="ns-next">
                            <span class="sr-only visually-hidden">Next page</span>
                            <svg role="presentation" aria-hidden="true" width="16" height="16" viewBox="0 0 19 15" fill="#000" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg);">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.647.146l.707.708L2.207 7H19v1H2.207l6.147 6.146-.707.708L.293 7.5 7.647.146z"></path>
                            </svg>
                        </PageLink>
                    </li>
                )}
            </ol>
        </nav>
    )
}
